(function () {
  'use strict';

  var context = window.SmoocheTrackingContext || {};
  var dataLayer = window.dataLayer = window.dataLayer || [];
  var cartAddPath = /\/cart\/add(?:\.js)?(?:\?|$)/;

  function asNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : 0;
  }

  function formatPrice(value) {
    return asNumber(value) / 100;
  }

  function push(event, ecommerce) {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: event,
      page_type: context.page_type || '',
      page_location: context.page_location || window.location.href,
      page_title: context.page_title || document.title,
      ecommerce: ecommerce || null
    });
  }

  function itemFromCartItem(item) {
    var variantId = item.variant_id || item.id || '';
    return {
      item_id: String(variantId),
      item_name: item.product_title || item.title || '',
      item_brand: item.vendor || '',
      item_category: item.product_type || '',
      item_variant: item.variant_title || '',
      price: formatPrice(item.final_price || item.price),
      quantity: asNumber(item.quantity) || 1
    };
  }

  function isCartAddRequest(url) {
    try {
      return cartAddPath.test(new URL(url, window.location.origin).pathname + new URL(url, window.location.origin).search);
    } catch (error) {
      return false;
    }
  }

  function trackCartAdd(response) {
    if (!response || !response.ok || typeof response.clone !== 'function') return;

    response.clone().json().then(function (item) {
      if (!item || !item.id) return;
      push('add_to_cart', {
        currency: context.currency || item.currency || '',
        value: formatPrice(item.final_line_price || item.final_price || item.price) * (asNumber(item.quantity) || 1),
        items: [itemFromCartItem(item)]
      });
    }).catch(function () {
      // A non-JSON cart response is not a Shopify add-to-cart success payload.
    });
  }

  function trackFetch() {
    if (!window.fetch || window.fetch.__smoocheTrackingPatched) return;
    var originalFetch = window.fetch;

    function trackedFetch(input, init) {
      var requestUrl = typeof input === 'string' ? input : input && input.url;
      var method = (init && init.method) || (input && input.method) || 'GET';
      return originalFetch.apply(this, arguments).then(function (response) {
        if (String(method).toUpperCase() === 'POST' && isCartAddRequest(requestUrl)) trackCartAdd(response);
        return response;
      });
    }

    trackedFetch.__smoocheTrackingPatched = true;
    window.fetch = trackedFetch;
  }

  function trackXmlHttpRequest() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__smoocheTrackingPatched) return;
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__smoocheTrackingMethod = method;
      this.__smoocheTrackingUrl = url;
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      this.addEventListener('loadend', function () {
        if (String(this.__smoocheTrackingMethod).toUpperCase() !== 'POST' || !isCartAddRequest(this.__smoocheTrackingUrl) || this.status < 200 || this.status >= 300) return;
        try {
          var item = JSON.parse(this.responseText);
          if (!item || !item.id) return;
          push('add_to_cart', {
            currency: context.currency || item.currency || '',
            value: formatPrice(item.final_line_price || item.final_price || item.price) * (asNumber(item.quantity) || 1),
            items: [itemFromCartItem(item)]
          });
        } catch (error) {
          // A non-JSON cart response is not a Shopify add-to-cart success payload.
        }
      });
      return originalSend.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.__smoocheTrackingPatched = true;
  }

  push('page_view');
  if (context.product) {
    push('view_item', {
      currency: context.currency || '',
      value: asNumber(context.product.price),
      items: [context.product]
    });
  }

  trackFetch();
  trackXmlHttpRequest();
}());
